import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/calendar.svg";
var CalendarOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  CalendarOutline_default as default
};
